"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var TreeRoot = function TreeRoot(_ref) {
  var maxHeight = _ref.maxHeight,
      children = _ref.children;
  var treeRootClasses = (0, _classnames.default)('TreeRoot', 'user-select-none');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: treeRootClasses,
    style: {
      maxHeight: maxHeight
    }
  }, children);
};

TreeRoot.displayName = 'TreeRoot';
TreeRoot.propTypes = {
  maxHeight: _propTypes.default.number
};
var _default = TreeRoot;
exports.default = _default;